import cn from 'classnames'
import * as React from 'react'
import { WrapperProps } from './VerticalTimeline.types'
import styles from './Wrapper.module.css'

export function Wrapper({ children, className, role = 'list', ...rest }: React.PropsWithChildren<WrapperProps>) {
  return (
    <div className={cn(styles.wrapper, className)} role={role} {...rest}>
      {children}
    </div>
  )
}
